"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleDetails = exports.animateOpenKeyframes = exports.animateCloseKeyframes = exports.animateOptions = void 0;
/**
 * 開閉処理
 */
/**
 * アニメーションの時間とイージングの設定
 */
exports.animateOptions = {
    duration: 300,
    easing: "ease-out",
};
/**
 * 閉じるキーフレーム
 */
const animateCloseKeyframes = (content) => [
    {
        height: `${content.offsetHeight}px`,
    },
    {
        height: 0,
    },
];
exports.animateCloseKeyframes = animateCloseKeyframes;
/**
 * 開くキーフレーム
 */
const animateOpenKeyframes = (content) => [
    {
        height: 0,
    },
    {
        height: `${content.offsetHeight}px`,
    },
];
exports.animateOpenKeyframes = animateOpenKeyframes;
/**
 * details要素の開閉処理
 */
const toggleDetails = () => {
    document.querySelectorAll(".js-toggleDetails").forEach((details) => {
        const summary = details.querySelector(".js-toggleDetails__summary");
        const content = details.querySelector(".js-toggleDetails__content");
        if (summary == null)
            return new Error("unexpected error: .js-toggleDetails__summary not found.");
        if (content == null)
            return new Error("unexpected error: .js-toggleDetails__content not found.");
        summary.addEventListener("click", (e) => {
            e.preventDefault();
            if (details.open) {
                summary.classList.remove("is-opened");
                const closeMenu = content.animate((0, exports.animateCloseKeyframes)(content), exports.animateOptions);
                closeMenu.onfinish = () => {
                    details.removeAttribute("open");
                };
            }
            else {
                summary.classList.add("is-opened");
                details.setAttribute("open", "true");
                content.animate((0, exports.animateOpenKeyframes)(content), exports.animateOptions);
            }
        });
    });
};
exports.toggleDetails = toggleDetails;
